export { ActivitiesTaskComponent } from './activities-task.component';



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/header/activities/activities-task/index.ts